/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  
  /* GLOBAL - remove transparent header from mobile */
  if (window.matchMedia("(max-width: 990px)").matches) {
    var Element = document.querySelector('.header__wrapper[data-header-transparent]')
    Element.setAttribute('data-header-transparent', 'false');    
  }
  


  // CART -- Terms and conditions
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Du skal acceptere vores handelsbetingelser for at gå til kassen.");
      return false;
    }
  });

  
  
  // PRODUCT - autoplay video in thumbnail
  var productVideoPlayButton = document.querySelector("button.deferred-media__poster");
  
  if (window.matchMedia("(min-width: 747px)").matches) {
    window.addEventListener('load', function () {
      if (productVideoPlayButton) {
        productVideoPlayButton.click();
      };
    });
  };
  
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
